import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { Card, Grid, Loader, Menu, Tab, TabProps } from "semantic-ui-react";

import { AppState, Room } from "../model";
import { roomSelector, basePathSelector, routeIdSelector } from "../selectors";
import { ApplicationState } from "../../../applicationState";

import { loadRoomDetail } from "../actions";

import * as details from "./details";

import { Link, push } from "redux-little-router";

export interface DispatchProps {
    push: (path: string) => void;
}

const tabs = (Object.keys(details) as (keyof typeof details)[]).map(k => details[k]);

export const Detail = () => {
    const roomId = useSelector(routeIdSelector);
    const room = useSelector<ApplicationState, Room | undefined>(s => roomSelector(s));
    const path = useSelector<ApplicationState, string>(state => state.router.pathname!); // eslint-disable-line @typescript-eslint/no-non-null-assertion
    const basePath = useSelector<ApplicationState>(state => basePathSelector(state));
    const tab = useSelector<ApplicationState, string>(state => currentTab(state));
    const dispatch = useDispatch();
    const handleTabChange = React.useCallback((event: any, { activeIndex }: TabProps) => {
        if (room === undefined || !("detailUpdated" in room)) { return; }
        dispatch(push(`${basePath}/${room?.id}${tabs[activeIndex as unknown as number]({
            room,
            path
        }).path}`, {}));
    }, [basePath, dispatch, path, room]);

    React.useEffect(() => {
        dispatch(loadRoomDetail({ roomId }));
    }, [dispatch, roomId]);

    if (room === undefined || !("detailUpdated" in room)) {
        return <Loader active />;
    }

    const panes = tabs.map(t => t({
        room,
        path
    }));
    const activeIndex = panes.slice(1).findIndex(p => tab && tab.startsWith(p.path)) + 1;

    const content = () => panes.length === 1
        ? <Card fluid>{panes[0].render()}</Card>
        : <Tab panes={panes} onTabChange={handleTabChange} activeIndex={activeIndex} />;

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column>
                    <h1>{room.name}</h1>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={3} as={Grid} padded>
                    <Grid.Column vertical as={Menu}>
                        <Menu.Item name="Rooms" as={Link} href={basePath}>
                            All Rooms
                        </Menu.Item>
                    </Grid.Column>
                </Grid.Column>

                <Grid.Column width={13}>
                    {content()}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

const currentTab = (state: AppState) => state.router.pathname!.substring( // eslint-disable-line @typescript-eslint/no-non-null-assertion
    basePathSelector(state).length + 1 + routeIdSelector(state).toString().length);
